export interface IUser {
  username: string;
  displayName: string;
  token: string;
  image?: string;
  role: string;
  hasTempPassword: boolean;
  activePlanName: string;
}

export interface IStudentEnvelope {
  dataCollection: IStudentUser[];
  dataCount: number;
}

export interface ITeacherEnvelope {
  dataCollection: ITeacherUser[];
  dataCount: number;
}

export interface IStudentUser {
  id: string;
  displayName: string;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
}

export interface ITeacherUser {
  id: string;
  displayName: string;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  gender: string;
  cpf: string;
  phoneCode: string;
  phoneNumber: string;
  birthDate: string;
}

export class TeacherFilter {
  name?: string = "";
}

export class StudentFilter {
  onlyActive: boolean = true;
  name?: string = "";
  paidStatus: string = "todos";
}

export interface IUserFormValues {
  email: string;
  oldPassword: string
  password: string;
  confirmPassword?: string;
  displayName?: string;
  username?: string;
  gender: string;
  cpf: string;
  terms?: boolean;
}

export interface ITeacherFormValues {
  firstName: string;
  lastName: string;
  email: string;
  gender: string;
  cpf: string;
  phoneCode: string;
  phoneNumber: string;
  birthDate: string;
}

export class UserFormValues {
  email: string = "";
  oldPassword: string = "";
  password: string = "";
  confirmPassword: string = "";
  displayName: string = "";
  username: string = "";
  gender: string = "";
  cpf: string = "";
  birthDate: string = "";

  constructor(init?: UserFormValues) {
    Object.assign(this, init);
  }
}

export class TeacherFormValues {
  id: string = "";
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  gender: string = "";
  cpf: string = "";
  phoneCode: string = "";
  phoneNumber: string = "";
  birthDate: string = "";

  constructor(init?: TeacherFormValues) {
    Object.assign(this, init);
  }
}

export interface IUserListReport {
  firstName: string;
  lastName: string;
  apelido: string;
  username: string;
  cpf: string;
  email: string;
  birthDate: string
  birthYear: string;
  age: string;
  gender: string;
  phoneNumber: string;
  status: string;
  createdDate: string;
  lastLoginDate: string;
  neighborhood: string;
  city: string;
  state: string;
  country: string;
  cep: string;
  totalMoneySpent: string;
}

export interface ITeacherCategoryEnvelope {
  dataCollection: ITeacherCategory[];
  dataCount: number;
}



export interface ITeacherCategory {
  id: string;
  appUserId: string;
  categoryId: string;
  categoryName: string;
}

export interface ITeacherCategoryFormValues {
  id: string;
  appUserId: string;
  categoryId: string;
}

export class TeacherCategoryFormValues {
  id: string = "";
  appUserId: string = "";
  categoryId: string = "";

  constructor(init?: TeacherCategoryFormValues) {
    Object.assign(this, init);
  }
}